import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { RegistrationlistComponent } from './registration-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpModule, JsonpModule } from '@angular/http';

const routes: Routes = [{
	path: '',
	data: {
      title: 'Registration Management',
      urls: [{title: 'Dashboard',url: '/'},{title: 'Registration Management'}]
    },
	component: RegistrationlistComponent
}];

@NgModule({
	imports: [
    	FormsModule,
    	CommonModule,
		HttpModule,
        JsonpModule,
        NgbModule.forRoot(),
    	RouterModule.forChild(routes)
    ],
	declarations: [RegistrationlistComponent]
})
export class RegistrationlistModule { }


// WEBPACK FOOTER //
// /Users/sheashay/Sites/ihsaa-ams-design/src/app/pages/officials/registration-list/registration-list.module.ts